import Fab from "@mui/material/Fab";
import { PropTypes } from "prop-types";

const ButtonFreeText = (props) => {
  const { text, handleClick, ...rest } = props;

  return (
    <Fab
      sx={{ width: 100 }}
      variant="extended"
      color="primary"
      onClick={handleClick}
      {...rest}
    >
      {text}
    </Fab>
  );
};

export default ButtonFreeText;

ButtonFreeText.propTypes = {
  handleClick: PropTypes.func.isRequired,
  text: PropTypes.string,
};
